module.exports = __webpack_public_path__ + "media/images/UK-bride-image1-92e98f2a40fde816f17abd48ed010f12.jpg";